import { Injectable } from '@angular/core';
import { type IReffable } from '@principle-theorem/shared';
import {
  type IRoutable,
  StateBasedNavigationService,
  type IContextualAction,
} from '@principle-theorem/ng-principle-shared';

@Injectable({
  providedIn: 'root',
})
export class LoadChatActionService implements IContextualAction {
  icon = 'open_in_new';
  name = 'View Chat';

  constructor(private _stateNav: StateBasedNavigationService) {}

  async do(chat: IRoutable | IReffable): Promise<void> {
    const uid: string = 'uid' in chat ? chat.uid : chat.ref.id;
    await this._stateNav.practice(['chats', uid]);
  }
}
